/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_List_DeleteInputs */

const cs_lead_list_delete = /** @type {(inputs: Lead_List_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat lead`)
};

const en_lead_list_delete = /** @type {(inputs: Lead_List_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete lead`)
};

/**
* | output |
* | --- |
* | "Delete lead" |
*
* @param {Lead_List_DeleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lead_list_delete = /** @type {((inputs?: Lead_List_DeleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_List_DeleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_list_delete(inputs)
	return cs_lead_list_delete(inputs)
});